Namespace 'Monitoring.Views.SocialContents'

class Monitoring.Views.SocialContents.SessionListItemView extends Backbone.View
  template: JST['backbone/templates/monitoring/sessions/session_list_item']

  initialize: ({@session}) ->
    @query = JSON.parse(@session.query)

  render: ->
    mode = @_sessionMode()
    @el = $ @template
      session: @session
      sessionMode: mode
      updatedAt: Date.create(@session.updated_at)
      isAnalysisMode: @query.analysisMode
    @_renderSessionIcon(mode)

    @

  _renderSessionIcon: (mode) ->
    @vueSessionIcon = new VueInBackbone.VueComponent(
      'session-mode-icon',
      {
        mode: mode,
        searchQuery: @query
      }
    )
    @el.find('#mode-icon').html(@vueSessionIcon.el)
    @vueSessionIcon.render()

  _tabIcons: ->
    switch
      when @query.analysisMode then []
      when @query.reviewMode then ['fa fa-tags']
      when @query.surveyMode then ['fa fa-file-text']
      else ['fa fa-comments']

  _sessionMode: ->
    switch
      when @query.analysisMode then 'analysis'
      when @query.reviewMode then 'review'
      when @query.surveyMode then 'survey'
      else 'explore'
